import { CompositionsSelector as CompositionsSelectorComponent } from './CompositionsSelector.component';
import { connector } from './CompositionsSelector.connector';

export const CompositionsSelector = connector(CompositionsSelectorComponent);
